// extracted by mini-css-extract-plugin
module.exports = {"windowDefault":"_3HyVt60GQmoGSuioCixLM9"};